module.exports = __webpack_public_path__ + "img/ic-deposit.6a72b9ec.svg";